import axios from 'axios'
import router from '@/router'
// axios.defaults.headers.common={Accept:'*/*'};

axios.defaults.withCredentials=true;
export function request(config){
	const instance=axios.create({
		withCredentials:true,
		method: "POST",
		baseURL:'http://info.itbx.cc/',
		timeout:5000,
	})


	instance.interceptors.request.use(config =>{
		return config
	},err => {
		// console.log(err)
	})


	//没登陆就重定向
	instance.interceptors.response.use(res =>{

		return res
	},err => {
		if(err.response.status==307){
			router.push('/login')
			err.response.status=301
		}

	})


	return instance(config)
}

export function request2(config){
	const instance2=axios.create({
		withCredentials:true,
		method: "GET",
		baseURL:'http://info.itbx.cc/',
		timeout:5000,
	})

	instance2.interceptors.request.use(config =>{
		return config
	},err => {
		if(err.response.status==307){
			router.push('/login')
			err.response.status=201
		}
	})

	return instance2(config)
}
